<template>
  <b-card-code v-if="$checkPermission($options.name, 'view')"  id="user-history" no-body>

    <div class="page-header">
      <b-row>
        <b-col md="12">
          <div class="filters">

            <div class="filter-column historyPicker">
              <date-range-picker
                  ref="picker"
                  :opens="'right'"
                  :append-to-body="true"
                  :calculate-position="positionPicker"
                  v-model="dateRange"
                  :locale-data="localeData"
                  :ranges="dateRanges"
                  :always-show-calendars="false"
                  @update="updateRange"
              >
                <template v-slot:input="picker" style="min-width: 350px;">
                  <fa-icon class="header-icon calendarIcon" :icon="['far', 'calendar-alt']"/>
                  {{ selected_picker_value(picker) }}
                </template>
              </date-range-picker>
            </div>
            <div class="filter-column">
              <v-select
                  @input="applyUserFilter"
                  placeholder="Օգտատեր"
                  id="vue-select-region"
                  :reduce="prefix => prefix.id"
                  v-model="filters.api"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="users"
                  class="selectorFilterApi"
              />
            </div>
            <div class="filter-column">
              <b-form-input
                  @change="filterName"
                  v-model="filters.name"
                  autocomplete="off"
                  @keydown="disableSymbol($event)"
                  id="owner_name"
                  type="text"
                  placeholder="Փնտրել..."
                  class="w-full text-uppercase opinionFilter"
                  clearable
              />
            </div>

          </div>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col md="12">
        <b-table
            striped
            hover
            responsive
            class="position-relative"
            :items="history"
            :fields="fields"
        >
          <template #cell(createdAt)="data">
            {{data.value | formatDate}}
          </template>

        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

          <!-- page length -->
          <b-form-group
              :label="'Գտնվել է ' + pagination.total + ' տող'"
              label-cols="3"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
          >
          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
                @input="changePage"
                v-model="pagination.current_page"
                :total-rows="pagination.total"
                :per-page="pagination.count"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>
        </b-card-body>
      </b-col>
    </b-row>

  </b-card-code>
</template>

<script>

import moduleApi from '@/store/api/moduleApi'
import store from '@/store'
import { BTable, BCardBody, BFormGroup, BPagination, BRow, BCol, BFormInput } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode'
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'api-history',
  components: {
    BCardCode,
    BCardBody,
    BTable,
    BFormGroup,
    BPagination,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    DateRangePicker
  },
  data() {
    return {
      API_STORE_MODULE_NAME: 'apiModule',
      filters: {
        api: null
      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      localeData: {
        applyLabel: 'Հաստատել',
        cancelLabel: 'Չեղարկել',
        ranges: [],
        firstDay: 1,
        format: 'dd/mm/yyyy',
        customRangeLabel: 'Այլ',
        daysOfWeek: ['Կիր', 'Երկ', 'Երք', 'Չոր', 'Հնգ', 'Ուրբ', 'Շբթ'],
        monthNames: ['Հուն', 'Փետ', 'Մար', 'Ապր', 'Մայ', 'Հուն', 'Հուլ', 'Օգ', 'Սեպ', 'Հոկ', 'Նոյ', 'Դեկ'],
      },
      fields: [
       {
          key: 'createdAt',
          label: 'Ամսաթիվ'
        },
        {
          key: 'provider',
          label: 'Օգտատեր'
        },
        {
          key: 'ip',
          label: 'IP հասցե'
        },
        {
          key: 'search',
          label: 'Որոնում'
        },
        {
          key: 'response',
          label: 'Պատասխան'
        },
      ],
    }
  },
  computed: {
    history() {
      return this.$store.state[this.API_STORE_MODULE_NAME].history
    },
    pagination() {
      return this.$store.state[this.API_STORE_MODULE_NAME].pagination
    },
    users() {
      return this.$store.state[this.API_STORE_MODULE_NAME].users.filter(e => e.status === true).map(e => ({
        label: e.title,
        id: e._id
      }))
    },
    dateRanges() {
      let today = new Date()

      let todayStart = new Date()
      let todayEnd = new Date()

      let yesterdayStart = new Date()
      yesterdayStart.setDate(today.getDate() - 1)
      let yesterdayEnd = new Date()
      yesterdayEnd.setDate(today.getDate() - 1)

      let thisWeekStart = new Date(new Date().setDate(new Date().getDate() + 1 - new Date().getDay()))
      let thisWeekEnd = new Date(new Date().setDate(new Date().getDate() + 1 - new Date().getDay() + 6))

      let lastWeekStart = new Date(new Date().setDate(new Date().getDate() - 6 - new Date().getDay()))
      let lastWeekEnd = new Date(new Date().setDate(new Date().getDate() - new Date().getDay()))

      let thisMonthStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      let thisMonthEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)

      let lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      let lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0)

      let currentMonth = today.getMonth()
      let thisQuarterStart
      let thisQuarterEnd
      let lastQuarterStart
      let lastQuarterEnd
      if (currentMonth >= 0 && currentMonth < 3) {
        thisQuarterStart = new Date(today.getFullYear(), 0, 1)
        thisQuarterEnd = new Date(new Date().getFullYear(), 2, 31)
        lastQuarterStart = new Date(today.getFullYear() - 1, 9, 1)
        lastQuarterEnd = new Date(today.getFullYear() - 1, 11, 31)
      } else if (currentMonth >= 3 && currentMonth < 6) {
        thisQuarterStart = new Date(today.getFullYear(), 3, 1)
        thisQuarterEnd = new Date(new Date().getFullYear(), 5, 30)
        lastQuarterStart = new Date(today.getFullYear(), 0, 1)
        lastQuarterEnd = new Date(new Date().getFullYear(), 2, 31)
      } else if (currentMonth >= 6 && currentMonth < 9) {
        thisQuarterStart = new Date(today.getFullYear(), 6, 1)
        thisQuarterEnd = new Date(new Date().getFullYear(), 8, 30)
        lastQuarterStart = new Date(today.getFullYear(), 3, 1)
        lastQuarterEnd = new Date(new Date().getFullYear(), 5, 30)
      } else {
        thisQuarterStart = new Date(today.getFullYear(), 9, 1)
        thisQuarterEnd = new Date(new Date().getFullYear(), 11, 31)
        lastQuarterStart = new Date(today.getFullYear(), 6, 1)
        lastQuarterEnd = new Date(new Date().getFullYear(), 8, 30)
      }

      let thisSemesterStart
      let thisSemesterEnd
      let lastSemesterStart
      let lastSemesterEnd
      if (currentMonth >= 0 && currentMonth < 5) {
        thisSemesterStart = new Date(today.getFullYear(), 0, 1)
        thisSemesterEnd = new Date(new Date().getFullYear(), 5, 30)
        lastSemesterStart = new Date(today.getFullYear() - 1, 6, 1)
        lastSemesterEnd = new Date(today.getFullYear() - 1, 11, 31)
      } else {
        thisSemesterStart = new Date(today.getFullYear(), 6, 1)
        thisSemesterEnd = new Date(new Date().getFullYear(), 11, 31)
        lastSemesterStart = new Date(today.getFullYear(), 0, 1)
        lastSemesterEnd = new Date(today.getFullYear(), 5, 30)
      }

      let thisYearStart = new Date(new Date().getFullYear(), 0, 1)
      let thisYearEnd = new Date(new Date().getFullYear(), 11, 31)
      let lastYearStart = new Date(new Date().getFullYear() - 1, 0, 1)
      let lastYearEnd = new Date(new Date().getFullYear() - 1, 11, 31)

      return {
        'Այսօր': [todayStart, todayEnd],
        'Երեկ': [yesterdayStart, yesterdayEnd],
        'Այս շաբաթ': [thisWeekStart, thisWeekEnd],
        'Անցած շաբաթ': [lastWeekStart, lastWeekEnd],
        'Այս ամիս': [thisMonthStart, thisMonthEnd],
        'Անցած ամիս': [lastMonthStart, lastMonthEnd],
        'Այս եռամսյակ': [thisQuarterStart, thisQuarterEnd],
        'Անցած եռամսյակ': [lastQuarterStart, lastQuarterEnd],
        'Այս կիսամյակ': [thisSemesterStart, thisSemesterEnd],
        'Անցած կիսամյակ': [lastSemesterStart, lastSemesterEnd],
        'Այս տարի': [thisYearStart, thisYearEnd],
        'Անցած տարի': [lastYearStart, lastYearEnd],
        'Բոլորը': [null, null],
      }
    },
    selected_picker_value() {
      return (data) => {
        if (data.startDate && data.endDate) {
          return this.$options.filters.formatDay(data.startDate) + ' - ' + this.$options.filters.formatDay(data.endDate)
        }
        return ''
      }
    }
  },
  created() {
    if (!store.hasModule(this.API_STORE_MODULE_NAME)) store.registerModule(this.API_STORE_MODULE_NAME, moduleApi)
    this.getHistory()
    this.getUsers()
  },
  methods: {

    applyUserFilter() {
      this.pagination.current_page = 1
      this.getHistory()
    },

    positionPicker(dropdownList, component) {
      const toggle = component.$refs.toggle.getBoundingClientRect()
      dropdownList.style.position = 'fixed'
      dropdownList.style.top = `${toggle.bottom + 4}px`
      dropdownList.style.left = `${toggle.left}px`
      dropdownList.style.right = 'auto'
      dropdownList.style.bottom = 'auto'
      dropdownList.style.transform = 'none'
      dropdownList.style.margin = '0'
    },

    updateRange() {
      if (this.dateRange.startDate) {
        this.dateRange.startDate.setHours(0, 0, 0, 0)
      }
      if (this.dateRange.endDate) {
        this.dateRange.endDate.setHours(23, 59, 59, 59)
      }
      this.pagination.current_page = 1
      this.getHistory()
    },

    getHistory() {
      const filterData = {
        ...this.filters,
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        current_page: this.pagination.current_page
      }
      this.$vs.loading()
      this.$store.dispatch(`${this.API_STORE_MODULE_NAME}/getHistory`, this.serialize(filterData))
          .then(() => {
            this.$vs.loading.close()
            const element = document.getElementById('group-menu-badge-api')
            if (element) {
              element.innerText = 0
            }
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$root.$emit('getError', error)
          })

    },

    getUsers() {
      this.$vs.loading()
      this.$store.dispatch(`${this.API_STORE_MODULE_NAME}/getUsers`, false)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$root.$emit('getError', error)
          })
    },

    serialize(obj) {
      let str = []
      for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
          if (typeof obj[p] !== 'undefined' && obj[p] !== null && obj[p] !== '') {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
          }
        }
      }
      return str.join('&')
    },

    changePage(page) {
      this.pagination.current_page = page
      this.getHistory()
    },
    filterName() {
      this.pagination.current_page = 1;
      this.getHistory()
    },
    disableSymbol(e) {
      if (!(/^[*a-zA-Z0-9ղցվա]*$/.test(e.key))) {
        e.preventDefault()
      }
    },
  }
}
</script>
<style lang="scss">
#user-history {
  .table-responsive {
    max-height: calc(var(--vh, 1vh) * 100 - 15rem);
    min-height: calc(var(--vh, 1vh) * 100 - 15rem);
  }
}
.selectorFilterApi {
  min-width: 300px
}
#user-history .historyPicker .vue-daterange-picker {
  margin-bottom: 0;
}
#user-history .historyPicker .reportrange-text {
  display: flex;
  align-items: center;
  min-height: 38px;
}
</style>
